import React, { useState } from 'react'
import "./C1.css";
import Product from "./Product"
import Carousel from 'react-bootstrap/Carousel'
import { useEffect } from 'react';
import axios from "./axios";
import ProductSkeleton from './components/skeleton/ProductSkeleton';

function C1() {
    const [fruits,setFruits]=useState([])
    const [vegitables,setVegetables]=useState([])
    const skeleton=[1,2,3,4]
    useEffect(()=>{
        axios({
            url:'/products/category/fruit',
            method:'get'
        }).then(res => setFruits(res.data)).catch(err => console.log("eee",err))
        axios({
            url:'/products/category/vegetable',
            method:'get'
        }).then(res => setVegetables(res.data)).catch(err => console.log("eee",err))
    },[])
    return (
        <section className="container-fluid">
            <Carousel>
                <Carousel.Item interval={4000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/L1-NNP3890-1200x300-12thaug.jpg"
                    alt="First slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={4000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/L1-NNP3904-1200x300-12thaug.jpg"
                    alt="Third slide"
                    />
                </Carousel.Item>
                <Carousel.Item interval={4000}>
                    <img
                    className="d-block w-100"
                    src="https://www.bigbasket.com/media/uploads/banner_images/L1-NNP3910-1200x300-12thaug.jpg"
                    alt="Third slide"
                    />
                </Carousel.Item>
            </Carousel>
           <img className="c1_ad1"src="https://www.bigbasket.com/media/uploads/flatpages/test-1/Fruits%20&%20vegetables.jpg" alt=""/>
            <h5 className="ml-5 mt-4">Fruits</h5>           
            <article className="row">  
                    {
                        fruits.length>0?
                        fruits.map((f,i)=>
                            <article className='col-md-3 col-sm-4' key={i}>
                            <Product
                            id={f._id}
                            title={f.title}
                            price={f.price}
                            rating={f.rating}
                            image={f.image}
                            stock={f.stock}
                            active={f.active}
                            />
                              </article>
                        ):
                        skeleton.map(s=>
                            <article className='col-md-3 col-sm-4' key={s}>
                                <ProductSkeleton />
                            </article>
                       )
                    }
            </article>
            
            <h5 className="ml-5 mt-4">Vegetabes</h5>  
            <article className="row">  
                    {
                        vegitables.length>0?
                        vegitables.map((f,i)=>
                            <article className='col-md-3 col-sm-4' key={i}>
                            <Product
                            id={f._id}
                            title={f.title}
                            price={f.price}
                            rating={f.rating}
                            image={f.image}
                            stock={f.stock}
                            active={f.active}
                            />
                              </article>
                        ):
                        skeleton.map(s=>
                            <article className='col-md-3 col-sm-4' key={s}>
                                <ProductSkeleton />
                            </article>
                       )
                    }
            </article>              
        </section>
    )
}

export default C1
